export default __webpack_public_path__ + "static/perpetua-io-ogimage-EN-e4e7dbfc794a2d19d2f01111aa997adf.png";